import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from "utils/axios/axiosBaseQuery"
import { authApi } from '../auth';

export const myProfileApi = createApi({
    reducerPath: 'myProfileApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/account",
    }),
    tagTypes: ["Schools"],
    endpoints: (builder) => ({
        getMySchoolData: builder.query({
            query: () => ({
                method: "GET",
                url: `/assigned_schools`
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["Schools"]
        }),
        getPoliciesData: builder.query({
            query: () => ({
                method: "GET",
                url: `/policies`
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["Schools"]
        }),
        updateOnboard: builder.mutation({
            query: ({ data, id }) => ({
                url: `/profile/on_boarding/${id}`,
                method: 'PUT',
                data
            }),
            invalidatesTags: ["Schools"],
            async onQueryStarted(id, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;

                    // Manually invalidate cache for 'Post' tag
                    dispatch(authApi.util.invalidateTags(['Profile']));
                } catch (error) {
                    // handle error if needed
                    console.log('error', error)
                }
            },
        }),
    }),
})

export const {
    useGetMySchoolDataQuery,
    useUpdateOnboardMutation,
    useGetPoliciesDataQuery
} = myProfileApi;